import { prokey_server } from './prokey.axios';
import { socket } from './prokey.websocket';

async function getDoctypes() {
  return await prokey_server.getDoctypes();
}

async function getTaskQueueInfo() {
  let data = [];
  let result = await prokey_server.getTaskQueueInfo();
  if (result && result.data) data = result.data;
  return data;
}

async function login(username, password) {
  try {
    const result = await prokey_server.login(username, password);
    if (result.status === 200) {
      socket.connect();
    }

    return result;
  } catch (error) {
    console.log(error);
    return {};
  }
}

async function updateRoleModules(roleId, moduleUpdates) {
  return prokey_server.updateRoleModules(roleId, moduleUpdates);
}

function removeAllListeners() {
  socket.removeAllListeners();
}

export const prokeyApi = {
  activeCheck: prokey_server.activeCheck,
  clearTask: prokey_server.clearTask,
  getAllRoles: prokey_server.getAllRoles,
  getAllUserRoles: prokey_server.getAllUserRoles,
  getAllModules: prokey_server.getAllModules,
  getAllRoleModules: prokey_server.getAllRoleModules,
  getDoctypes,
  getTaskQueueInfo,
  getUserDetails: prokey_server.getUserDetails,
  getVersion: prokey_server.getVersion,
  getSsoConfig: prokey_server.getSsoConfig,
  getSamlConfig: prokey_server.getSamlConfig,
  startSsoLogin: prokey_server.startSsoLogin,
  startSamlLogin: prokey_server.startSamlLogin,
  login,
  logout: prokey_server.logout,
  removeAllListeners,
  getAllUsers: prokey_server.getAllUsers,
  addUser: prokey_server.addUser,
  addBulkUsers: prokey_server.addBulkUsers,
  updateUsers: prokey_server.updateUsers,
  addRole: prokey_server.addRole,
  removeRoles: prokey_server.removeRoles,
  removeUserRole: prokey_server.removeUserRole,
  addUserRole: prokey_server.addUserRole,
  addModule: prokey_server.addModule,
  removeModules: prokey_server.removeModules,
  removeRoleModule: prokey_server.removeRoleModule,
  addRoleModule: prokey_server.addRoleModule,
  updateRoleModules,
  getRequestAccess: prokey_server.getRequestAccess,
  postRequestAccess: prokey_server.postRequestAccess,
  isPasswordResetEnabled: prokey_server.isPasswordResetEnabled,
  resetPassword: prokey_server.resetPassword,
  requestPasswordReset: prokey_server.requestPasswordReset,
  getOcrodTest: prokey_server.getOcrodTest,
  getOcrodProcesses: prokey_server.getOcrodProcesses,
  getOcrodBatchList: prokey_server.getOcrodBatchList,
  getOcrodBatch: prokey_server.getOcrodBatch,
  postOcrodBatch: prokey_server.postOcrodBatch,
  getReportNames: prokey_server.getReportNames,
  getReport: prokey_server.getReport,
  getResourceCpu: prokey_server.getResourceCpu,
  getResourceMem: prokey_server.getResourceMem,
  getSystemStartDateTime: prokey_server.getSystemStartDateTime,
  getNumberOfTasks: prokey_server.getNumberOfTasks,
  getNumberOfUsersLoggedIn: prokey_server.getNumberOfUsersLoggedIn,
  getNumberOfUsersActivelyKeying: prokey_server.getNumberOfUsersActivelyKeying,
  getNumberOfThreads: prokey_server.getNumberOfThreads,
  getNumberOfConversionsPerThread: prokey_server.getNumberOfConversionsPerThread,
  getNumberOfImagesConvertedByLambda: prokey_server.getNumberOfImagesConvertedByLambda,
  getNumberOfImagesConvertedBySystem: prokey_server.getNumberOfImagesConvertedBySystem,
  getBatchName: prokey_server.getBatchName,
  calcAvailableMemory: prokey_server.calcAvailableMemory,
};

export const actions = {
  addField            : 'add-fields',
  clearTask           : 'clearTask',
  removeFields        : 'remove-fields',
  removeTaskQueueItem : 'removeTaskQueueItem',
  setDoctypes         : 'set-doctypes',
  setDocuments        : 'set-documents',
  setTask             : 'task',
  setTaskQueueInfo    : 'taskQueueInfo',
  updateField         : 'update-field',
  updateTaskQueueInfo : 'updateTaskQueueInfo',
  inactive            : 'inactive',
};
